module.exports = __webpack_public_path__ + "img/SKMJ_limit11.d0d6b407.jpg";